export const TALENTIT = 'Talent-IT';
export const TALENT2TEST = 'Talent2Test';
export const TEAM4TALENT = 'Team4Talent';
export const CYBERTALENT = 'CyberTalent';
export const TALENT4INSIGHT = 'Talent4Insight';